import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { api } from '../utils/api';

const STATUS_COLORS = { aprovado:'#0FA36B', pendente:'#F59E0B', nao_verificado:'#9095A8' };
const STATUS_LABELS = { aprovado:'Aprovado', pendente:'Pendente', nao_verificado:'Não verificado' };

export default function Fornecedores() {
  const { token } = useAuth();
  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtros, setFiltros] = useState({ busca:'', segmento:'', status:'' });
  const [selecionado, setSelecionado] = useState(null);

  const carregar = () => {
    const params = new URLSearchParams();
    if (filtros.busca) params.set('busca', filtros.busca);
    if (filtros.segmento) params.set('segmento', filtros.segmento);
    if (filtros.status) params.set('status', filtros.status);
    api.get(`/fornecedores?${params}`, token).then(setLista).catch(console.error).finally(()=>setLoading(false));
  };

  useEffect(() => { carregar(); }, [filtros, token]);

  const segmentos = [...new Set(lista.map(f=>f.segmento).filter(Boolean))].sort();

  return (
    <div style={{padding:'28px 32px'}}>
      <div style={{marginBottom:24}}>
        <h1 style={{fontSize:20,fontWeight:700,color:'#0B0E1A',margin:0}}>Base de Fornecedores</h1>
        <p style={{fontSize:13,color:'#9095A8',margin:'4px 0 0'}}>Fornecedores verificados para sua importação. {lista.length} resultado(s)</p>
      </div>

      {/* Filtros */}
      <div style={{display:'flex',gap:10,marginBottom:20,flexWrap:'wrap'}}>
        <input placeholder="Buscar por empresa, produto..." value={filtros.busca}
          onChange={e=>setFiltros(f=>({...f,busca:e.target.value}))}
          style={{flex:1,minWidth:200,padding:'9px 14px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none'}} />
        <select value={filtros.segmento} onChange={e=>setFiltros(f=>({...f,segmento:e.target.value}))}
          style={{padding:'9px 14px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none',background:'#fff'}}>
          <option value="">Nicho: todos</option>
          {segmentos.map(s=><option key={s} value={s}>{s}</option>)}
        </select>
        <select value={filtros.status} onChange={e=>setFiltros(f=>({...f,status:e.target.value}))}
          style={{padding:'9px 14px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none',background:'#fff'}}>
          <option value="">Status: todos</option>
          <option value="aprovado">Aprovado</option>
          <option value="pendente">Pendente</option>
          <option value="nao_verificado">Não verificado</option>
        </select>
      </div>

      {/* Tabela horizontal */}
      <div style={{background:'#fff',borderRadius:12,boxShadow:'0 1px 4px rgba(0,0,0,.06)',overflow:'hidden'}}>
        <table style={{width:'100%',borderCollapse:'collapse'}}>
          <thead>
            <tr style={{borderBottom:'1px solid #F4F5F9',background:'#F9FAFB'}}>
              {['Empresa','Nicho','País · Cidade','Status','OEM','PL',''].map(h=>(
                <th key={h} style={{padding:'10px 16px',textAlign:'left',fontSize:11,fontWeight:600,color:'#9095A8',textTransform:'uppercase',letterSpacing:'.06em'}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={7} style={{padding:24,textAlign:'center',color:'#9095A8',fontSize:13}}>Carregando...</td></tr>}
            {!loading && lista.length===0 && <tr><td colSpan={7} style={{padding:32,textAlign:'center',color:'#9095A8',fontSize:13}}>Nenhum fornecedor encontrado.</td></tr>}
            {lista.map(f=>(
              <tr key={f.id} style={{borderBottom:'1px solid #F4F5F9',cursor:'pointer',transition:'.1s'}}
                onMouseEnter={e=>e.currentTarget.style.background='#F9FAFB'}
                onMouseLeave={e=>e.currentTarget.style.background=''}
                onClick={()=>api.get(`/fornecedores/${f.id}`,token).then(setSelecionado)}>
                <td style={{padding:'12px 16px'}}>
                  <div style={{fontSize:13,fontWeight:600,color:'#0B0E1A'}}>{f.empresa}</div>
                  <div style={{fontSize:11,color:'#9095A8'}}>{f.tipo||'—'}</div>
                </td>
                <td style={{padding:'12px 16px'}}>
                  {f.segmento ? <span style={{fontSize:11,background:'#EEF1FF',color:'#1A2ECC',padding:'2px 8px',borderRadius:99}}>{f.segmento}</span> : <span style={{fontSize:11,color:'#9095A8'}}>—</span>}
                </td>
                <td style={{padding:'12px 16px',fontSize:12,color:'#6B7289'}}>
                  {[f.pais, f.cidade].filter(Boolean).join(' · ') || '—'}
                </td>
                <td style={{padding:'12px 16px'}}>
                  <span style={{fontSize:11,fontWeight:600,padding:'3px 8px',borderRadius:99,
                    background:(STATUS_COLORS[f.status]||'#9095A8')+'22',
                    color:STATUS_COLORS[f.status]||'#9095A8'}}>
                    {STATUS_LABELS[f.status]||f.status}
                  </span>
                </td>
                <td style={{padding:'12px 16px',fontSize:12,color:f.aceita_oem?'#0FA36B':'#9095A8'}}>{f.aceita_oem?'✓':'✗'}</td>
                <td style={{padding:'12px 16px',fontSize:12,color:f.aceita_private_label?'#0FA36B':'#9095A8'}}>{f.aceita_private_label?'✓':'✗'}</td>
                <td style={{padding:'12px 16px'}}>
                  <span style={{fontSize:12,color:'#1A2ECC',fontWeight:600}}>Ver →</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal detalhe */}
      {selecionado && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.4)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}
          onClick={e=>e.target===e.currentTarget&&setSelecionado(null)}>
          <div style={{background:'#fff',borderRadius:16,padding:32,width:560,maxHeight:'85vh',overflowY:'auto',boxShadow:'0 8px 40px rgba(0,0,0,.15)'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:20}}>
              <div>
                <h2 style={{margin:0,fontSize:18,fontWeight:700,color:'#0B0E1A'}}>{selecionado.empresa}</h2>
                <div style={{fontSize:12,color:'#6B7289',marginTop:4}}>{[selecionado.cidade,selecionado.estado,selecionado.pais].filter(Boolean).join(' · ')}</div>
                <span style={{display:'inline-block',marginTop:8,fontSize:11,fontWeight:600,padding:'3px 10px',borderRadius:99,
                  background:(STATUS_COLORS[selecionado.status]||'#9095A8')+'22',color:STATUS_COLORS[selecionado.status]||'#9095A8'}}>
                  {STATUS_LABELS[selecionado.status]||selecionado.status}
                </span>
              </div>
              <button onClick={()=>setSelecionado(null)} style={{background:'none',border:'none',fontSize:22,cursor:'pointer',color:'#9095A8'}}>×</button>
            </div>

            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:16}}>
              {[['Tipo',selecionado.tipo],['Segmento',selecionado.segmento],['Principais produtos',selecionado.principais_produtos]].map(([l,v])=>v&&(
                <div key={l} style={{gridColumn:l==='Principais produtos'?'1/-1':'auto'}}>
                  <div style={{fontSize:11,fontWeight:600,color:'#9095A8',marginBottom:3}}>{l.toUpperCase()}</div>
                  <div style={{fontSize:13,color:'#0B0E1A'}}>{v}</div>
                </div>
              ))}
              <div><div style={{fontSize:11,fontWeight:600,color:'#9095A8',marginBottom:3}}>ATACADO REAL</div><span style={{color:selecionado.atacado_real?'#0FA36B':'#9095A8'}}>{selecionado.atacado_real?'✓ Sim':'✗ Não'}</span></div>
              <div><div style={{fontSize:11,fontWeight:600,color:'#9095A8',marginBottom:3}}>ACEITA OEM</div><span style={{color:selecionado.aceita_oem?'#0FA36B':'#9095A8'}}>{selecionado.aceita_oem?'✓ Sim':'✗ Não'}</span></div>
              <div><div style={{fontSize:11,fontWeight:600,color:'#9095A8',marginBottom:3}}>PRIVATE LABEL</div><span style={{color:selecionado.aceita_private_label?'#0FA36B':'#9095A8'}}>{selecionado.aceita_private_label?'✓ Sim':'✗ Não'}</span></div>
            </div>

            {(selecionado.email||selecionado.telefone||selecionado.site||selecionado.wechat) && (
              <div style={{background:'#F4F5F9',borderRadius:10,padding:14,marginBottom:14}}>
                <div style={{fontSize:12,fontWeight:700,color:'#0B0E1A',marginBottom:10}}>Contato</div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
                  {selecionado.email&&<div><div style={{fontSize:10,color:'#9095A8'}}>E-mail</div>
                    <div style={{display:'flex',alignItems:'center',gap:6}}>
                      <a href={`mailto:${selecionado.email}`} style={{fontSize:12,color:'#1A2ECC'}}>{selecionado.email}</a>
                      <button onClick={()=>navigator.clipboard.writeText(selecionado.email)} style={{background:'#F4F5F9',border:'none',borderRadius:4,padding:'2px 6px',fontSize:10,cursor:'pointer',color:'#6B7289'}}>📋</button>
                    </div></div>}
                  {selecionado.telefone&&<div><div style={{fontSize:10,color:'#9095A8'}}>Telefone/WhatsApp</div>
                    <div style={{display:'flex',alignItems:'center',gap:6}}>
                      <div style={{fontSize:12}}>{selecionado.telefone}</div>
                      <button onClick={()=>navigator.clipboard.writeText(selecionado.telefone)} style={{background:'#F4F5F9',border:'none',borderRadius:4,padding:'2px 6px',fontSize:10,cursor:'pointer'}}>📋</button>
                    </div></div>}
                  {selecionado.site&&<div><div style={{fontSize:10,color:'#9095A8'}}>Site</div>
                    <div style={{display:'flex',alignItems:'center',gap:6}}>
                      <a href={selecionado.site} target="_blank" rel="noreferrer" style={{fontSize:12,color:'#1A2ECC'}}>{selecionado.site}</a>
                      <button onClick={()=>navigator.clipboard.writeText(selecionado.site)} style={{background:'#F4F5F9',border:'none',borderRadius:4,padding:'2px 6px',fontSize:10,cursor:'pointer'}}>📋</button>
                    </div></div>}
                  {selecionado.wechat&&<div><div style={{fontSize:10,color:'#9095A8'}}>WeChat</div>
                    <div style={{display:'flex',alignItems:'center',gap:6}}>
                      <div style={{fontSize:12}}>{selecionado.wechat}</div>
                      <button onClick={()=>navigator.clipboard.writeText(selecionado.wechat)} style={{background:'#F4F5F9',border:'none',borderRadius:4,padding:'2px 6px',fontSize:10,cursor:'pointer'}}>📋</button>
                    </div></div>}
                </div>
              </div>
            )}

            {selecionado.observacoes&&<div style={{marginBottom:14}}><div style={{fontSize:11,fontWeight:600,color:'#9095A8',marginBottom:4}}>OBSERVAÇÕES</div><div style={{fontSize:13,color:'#3D4461',whiteSpace:'pre-wrap'}}>{selecionado.observacoes}</div></div>}

            {selecionado.arquivos?.length>0&&(
              <div>
                <div style={{fontSize:12,fontWeight:700,color:'#0B0E1A',marginBottom:10}}>Documentos</div>
                {selecionado.arquivos.map(a=>(
                  <div key={a.id} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'8px 12px',background:'#F4F5F9',borderRadius:8,marginBottom:6}}>
                    <span style={{fontSize:13,color:'#0B0E1A'}}>{a.nome}</span>
                    <a href={a.url} target="_blank" rel="noreferrer" style={{background:'#EEF1FF',color:'#1A2ECC',borderRadius:6,padding:'5px 12px',fontSize:12,fontWeight:600,textDecoration:'none'}}>Abrir</a>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
